<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>
    <div class="">
      <div class="mr-3 mx-1 rounded content_warranty" >
        <div class="ma-10">
          <v-row class="py-10">
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="advicesDetail.fullname"
                  v-model="advicesDetail.fullname"
                  label="Họ tên"
                  placeholder="Nhập họ tên"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  type="number"
                  :text="advicesDetail.phone"
                  v-model="advicesDetail.phone"
                  label="Số điện thoại"
                  placeholder="Số điện thoại"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="advicesDetail.address"
                  v-model="advicesDetail.address"
                  label="Địa chỉ"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  :text="advicesDetail.name_product"
                  v-model="advicesDetail.name_product"
                  label="Tên sản phẩm"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                  filled
                  :text="advicesDetail.note"
                  v-model="advicesDetail.note"
                  label="Ghi chú"
                  placeholder="Nhập ghi chú"
                  background-color="#EDF2F7"
              >
              </v-textarea>
            </v-col>
            <v-col cols="4">
              <v-select
                  filled
                  class="width-input"
                  background-color="#EDF2F7"
                  v-model="advicesDetail.status"
                  :items="active"
                  item-text="name"
                  item-value="id"
                  label="Chọn trạng thái"
              ></v-select>
            </v-col>
          </v-row>
        </div>
      </div>
      <div class="justify-center text-center my-5 border_bottom">
        <v-btn color="primary" width="180" @click="add_advise">
          Lưu
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import {
  SAVE_ADVISE,
} from "@/store/modules/advise";

export default {
  data() {
    return {
      active: [
        {id:1, name:'CHƯA TƯ VẤN'},
        {id:2, name:'ĐANG TƯ VẤN'},
        {id:3, name:'ĐÃ TƯ VẤN'},
        {id:4, name:'BỎ QUA'},
      ],
      page: "Thêm mới yêu cầu tư vấn",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Yêu cầu tư vấn",
          disabled: true,
        },
        {
          text: "Thêm mới yêu cầu tư vấn",
          disabled: true,
        },
      ],
      advicesDetail: {
        fullname:'',
        note:'',
        name_product:'',
        address:'',
        phone:'',
        status:null,
      }
    };
  },
  watch: {

  },
  mounted() {
  },
  async created() {

  },
  methods: {
    add_advise() {
      let params = {
        id: this.$route.params.id,
        name_product:this.advicesDetail.name_product,
        phone:this.advicesDetail.phone,
        address:this.advicesDetail.address,
        status:this.advicesDetail.status,
        note:this.advicesDetail.note,
        fullname:this.advicesDetail.fullname,
      }
      this.$store.dispatch(`${SAVE_ADVISE}`, params).then((data) => {
        if (data) {
          if(data.data.status == 1) {
            this.$toasted.success('Cập nhật thành công!', {
              duration:1000,
              position:'top-center'
            })
            this.$router.push("/advise");
          }
          else {
            alert(data.data.error)
          }
        }
      });
    },
  }
};
</script>
<style scoped lang="scss">
.content_warranty {
  width: 60%; background: #ffffff;
  min-height: 600px;
  //.v-text-field {
  //  height: 60px !important;
  //}
}
.border_bottom {
  width: 60%;
}

</style>